import { useEffect } from 'react';
import './HomeComponents.css';

interface DownloadSectionProps {
  id?: string;
}

const DownloadSection = ({ id }: DownloadSectionProps) => {
  const redirectToDeviceStore = (platform: 'android' | 'ios') => {
    const ua = navigator.userAgent || navigator.vendor || (window as any).opera;
    const isAndroid = /android/i.test(ua);
    const isIOS = /iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream;
    const androidLink = "https://play.google.com/store/apps/details?id=com.olitask.app";
    const iosLink = "https://apps.apple.com/us/app/olitask/id6756482938";
    const deepLink = "oliveeb://open";

    if (platform === 'android') {
      if (isAndroid) {
        window.location.href = deepLink;
        setTimeout(() => { window.location.href = androidLink; }, 1500);
      } else {
        window.open(androidLink, "_blank");
      }
    } else {
      if (isIOS) {
        window.location.href = deepLink;
        setTimeout(() => { window.location.href = iosLink; }, 1500);
      } else {
        window.open(iosLink, "_blank");
      }
    }
  };

  useEffect(() => {
    const pageUrl = window.location.href.split("#")[0];
    const qrUrl = "https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=" + encodeURIComponent(pageUrl);
    const qrImage = document.getElementById("qrImage") as HTMLImageElement;
    if (qrImage) qrImage.src = qrUrl;
  }, []);

  return (
    <section className="download-section" id={id}>
      <div className="download-container">
        <div className="download-content">
          <h2>Download Olitask Today</h2>
          <p>Get instant access to thousands of local helpers. Available on Android and iOS.</p>
          <div className="download-buttons">
            <button className="download-btn" onClick={() => redirectToDeviceStore('android')}>
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 0 1 0 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z"/>
              </svg>
              <div className="download-btn-text">
                <span>Get it on</span>
                <span>Google Play</span>
              </div>
            </button>
            <button className="download-btn" onClick={() => redirectToDeviceStore('ios')}>
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
              </svg>
              <div className="download-btn-text">
                <span>Download on the</span>
                <span>App Store</span>
              </div>
            </button>
          </div>
        </div>
        <div className="qr-section">
          <h3>Scan to Download</h3>
          <div className="qr-code">
            <img id="qrImage" alt="QR Code" />
          </div>
          <p>Point your phone camera at the QR code to download the app</p>
        </div>
      </div>
    </section>
  );
};

export default DownloadSection;